import {
  ArrowRightStartOnRectangleIcon,
  Cog6ToothIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline"
import useUser from "@/hooks/useUser"
import { Modals, useModals } from "@/hooks/useModals"
import HelpModal from "@/modals/HelpModal"
import NavMenuButton from "./NavMenuButton"

const UserMenu = () => {
  const { user, signOut } = useUser()
  const { openModal } = useModals()

  return (
    <div>
      <div className="space-y-2 py-4">
        <NavMenuButton
          onClick={() => openModal(Modals.Help)}
          name="Help & Support"
          icon={<InformationCircleIcon />}
        />
        <NavMenuButton
          href="/settings"
          name="Settings"
          icon={<Cog6ToothIcon />}
        />
      </div>

      <div className="pb-safe-or-4 -mx-6 flex items-center justify-between gap-x-3 border-t border-gray-200 bg-gray-100 px-6 pt-4">
        <div className="line-clamp-1 max-w-[155px] flex-1 text-sm font-semibold text-gray-700">
          {user?.name ?? user?.email}
        </div>
        <button
          onClick={signOut}
          className="h-10 shrink-0 rounded-lg px-2 text-gray-500 hover:bg-gray-200 hover:text-gray-900"
        >
          <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
          <span className="sr-only">Sign out</span>
        </button>
      </div>

      <HelpModal />
    </div>
  )
}

export default UserMenu
